import { Component, computed, OnInit, signal } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { OrbitFormClaimService } from '../../../../services/orbit-form-claim.service';
import { ORBIT_BUNDLE, ORBIT_BUNDLE_SESSION_KEY } from '../../../../../constants';
import { RadioButtonComponent } from '../../../../../../../shared/components/forms/radio-button/radio-button.component';
import { FormsModule } from '@angular/forms';
import { ButtonComponent } from '../../../../../../../shared/components/button/button.component';
import { LowerCasePipe } from '@angular/common';
import { AppInfo } from '../../../../../../../global/environment';

@Component({
  selector: 'app-product-type',
  imports: [RadioButtonComponent, FormsModule, ButtonComponent, LowerCasePipe],
  templateUrl: './product-type.component.html',
  styleUrl: './product-type.component.scss',
})
export class ProductTypeComponent implements OnInit {
  planNumber = signal<string | undefined>(undefined);

  selectedProductType: string | undefined = undefined;
  showError = false;

  protected viewModel = computed(() => {
    const claimData = this.orbitFormClaimsService.state.claimData;
    return {
      category:
        claimData.superCategory.applianceSuperCategory !== 'UNKNOWN'
          ? claimData.superCategory.applianceSuperCategory
          : 'product',
      productTypeOptions: claimData.productTypesArray ?? [],
      mmrLink: `${AppInfo.Environment.claimsURL}/my-plans/${this.planNumber()}/claims`,
      loading: this.orbitFormClaimsService.state.submittingValue,
    };
  });

  get vm() {
    return this.viewModel();
  }

  constructor(
    private readonly route: ActivatedRoute,
    private readonly orbitFormClaimsService: OrbitFormClaimService
  ) {}

  ngOnInit() {
    const planNumber = this.route.snapshot.params['planNumber'];

    this.planNumber.set(planNumber);
    // LiveChat.hideLiveChatLauncher();

    const bundleValue = sessionStorage.getItem(ORBIT_BUNDLE);
    const bundleKey = sessionStorage.getItem(ORBIT_BUNDLE_SESSION_KEY);

    if (bundleValue) {
      if (!this.orbitFormClaimsService.state.claimData) {
        this.orbitFormClaimsService.handleLoadedInData(JSON.parse(bundleValue));
      }
      return;
    }

    if (bundleKey) {
      this.orbitFormClaimsService.loadBundle(bundleKey!, false);
      return;
    }

    window.location.href = this.vm.mmrLink;
  }

  goToNextStep() {
    if (this.vm.loading) {
      return;
    }

    if (!this.selectedProductType) {
      this.showError = true;
      return;
    }

    this.orbitFormClaimsService.storeValue('productType', {
      productType: this.selectedProductType,
    });

    this.orbitFormClaimsService.moveStepForward('product-type');
  }
}
